import { SimpleGrid, VStack, Divider } from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

// Components
import MatchingScore from '../../../../../../../../common/src/components/MatchingScore';
import LabelValue from '../../../../../../components/offers/LabelValue';
import useIsNewRoute from '../../../../../offers/hooks/useIsNewRoute';
import ActiveButton from '../../shared/ActiveButton';
import ComparisonMatrixOfferHeader from './ComparisonMatrixOfferHeader';

interface Props {
  Icon: React.ReactElement;
  insuranceCompany: string;
  insuranceName: string;
  premium: string;
  score: number;
  isSelected: boolean;
  addToSelectedOffers: () => void;
  removeFromSelectedOffers: () => void;
}

const ComparisonMatrixOffer: React.FC<React.PropsWithChildren<Props>> = ({
  Icon,
  insuranceCompany,
  insuranceName,
  premium,
  score,
  isSelected,
  addToSelectedOffers,
  removeFromSelectedOffers,
  ...otherProps
}) => {
  const { t } = useTranslation();
  const isNewRoute = useIsNewRoute();

  return (
    <VStack
      align="streetch"
      spacing="0"
      w="64"
      h="64"
      bg="white"
      border="1px solid"
      borderColor="gray.50"
      borderRadius="md"
      boxShadow="level4"
      divider={<Divider borderColor="gray.50" />}
      {...otherProps}
    >
      <ComparisonMatrixOfferHeader
        Icon={Icon}
        title={insuranceCompany}
        description={insuranceName}
      />
      <VStack
        spacing="4"
        justify="space-between"
        flexGrow={1}
        p="4"
        align="stretch"
      >
        <SimpleGrid columns={2} gap="4">
          <LabelValue label={t('Pricing')}>{premium}</LabelValue>
          {score !== null && (
            <LabelValue label={t('Matching score')}>
              <MatchingScore score={score} />
            </LabelValue>
          )}
        </SimpleGrid>
        {!isNewRoute && (
          <ActiveButton
            onClick={
              isSelected ? removeFromSelectedOffers : addToSelectedOffers
            }
            isActive={isSelected}
          >
            {isSelected
              ? t('Remove from chosen offers')
              : t('Add to chosen offers')}
          </ActiveButton>
        )}
      </VStack>
    </VStack>
  );
};

export default ComparisonMatrixOffer;
